export default "__VITE_ASSET__BkH6tCgt__"